module.exports = __webpack_public_path__ + "media/images/athletes/1557-2347ea17c28b6f5ceb960ef45197c4c3.png";